// extracted by mini-css-extract-plugin
export default {"buttonContainer":"SolveHeader_buttonContainer__mtD7t"};